<app-offcanvas-base [returnUrl]="returnUrl">
  <ng-container title>Create new subscription card</ng-container>
  <ng-container body>
    @if (checkingCards()) {
      <app-loader [loadingText]="'Checking available cards...'"></app-loader>
    } @else {
      @if (hasAvailableCards()) {
        @if (form) {
          <form
            [formGroup]="form"
            [boFormOptions]="options"
            (ngSubmit)="onSubmit()"
            novalidate
            class="bg-transparent">
            <bo-non-field-errors />

            <app-form-field
              boFieldPath="name"
              placeholder="What do you want to name this card?"
              label="Card name"
              [inputFunction]="filterLettersOnly"></app-form-field>
            <div class="mb-4">
              <app-select-field
                boFieldPath="holder"
                [options]="employeeAdminOptions$"
                [closeOnSelect]="true"
                [searchable]="true"
                [placeholder]="'Search an employee'"
                label="Manager of card"></app-select-field>
            </div>

            <app-toggle-switch
              (switchChange)="onToggleRecurring($event)"
              label="Recurring top-up"
              id="recurringTopUpSwitch"
              [showTooltip]="true"
              [tooltipText]="tooltipText"></app-toggle-switch>

            @if (showRecurringTopUp()) {
              <app-select-topup-frequency
                (frequencyChange)="handleFrequencyChange($event)"
                [initialValue]="defaultFrequency"></app-select-topup-frequency>

              <p class="form-label">What is the target balance for the card?</p>
              <div class="currency-mask">
                <app-form-field
                  class="mb-0"
                  boFieldPath="amount"
                  label="R0.00"
                  [hideLabel]="true"
                  [addCurrencyMask]="true"
                  [currencyMaskOptions]="maskConfig"></app-form-field>
              </div>
              <app-card-limit-display
                (hasCardLimitError)="handleCardLimitError($event)"
                [selectedFrequency]="selectedFrequency()"
                [amount]="form.get('amount')?.value"></app-card-limit-display>
            }

            <div class="row offcanvas-buttons">
              <div class="col-12 col-sm-auto ms-sm-auto">
                <app-submit
                  btnID="createRuleSubmitBtn"
                  [disabled]="!form.valid"
                  [busy]="busy"
                  [icon]="false"
                  label="Create"></app-submit>
              </div>
            </div>
          </form>
        } @else {
          <app-loader [loadingText]="'Loading form...'"></app-loader>
        }
      } @else {
        <app-no-cards-available-display></app-no-cards-available-display>
      }
    }
  </ng-container>
</app-offcanvas-base>
